import {Factory} from '../node/index.js'
import {normalizeFactoryPath} from '../node/factory.js'
import {convert} from '../util/index.js'

// The model file uses a factory map
export function FactoryMap() {

    // the key to the map is the full factory path
    this.map = new Map()
}
FactoryMap.prototype = {

    reset() {
        this.map.clear()
    },

    size() {
        return this.map.size
    },

    // get the factories from the strings in the file
    cook(model) {

        // get the arl of the model
        const modelArl = model.getArl()

        for (const rawFactory of model.raw.factories) {

            // Top-level factories are a file index. Accept the legacy object
            // form while models transition to canonical string entries.
            const rawPath = typeof rawFactory === 'string' ? rawFactory : rawFactory?.path
            if (typeof rawPath !== 'string' || !rawPath.trim()) continue

            // the factories have to be resolved wrt the file that contains them
            const normalized = normalizeFactoryPath(rawPath)
            const arl = modelArl.resolve(normalized.path)

            // get the full path of the factory
            const fullPath = arl.getFullPath()

            // check if we have already handled this file...
            if ( this.map.has( fullPath)) continue

            // create the factory - we just need the arl here, so no factory name required
            const factory = new Factory()

            // save the arl
            factory.arl = arl
            factory.pathKind = normalized.pathKind

            // and add the factory
            this.map.set(fullPath, factory)
        }
    }, 

    // only adds new factory files
    add(factory) {

        const fullPath = factory.arl.getFullPath()

        // check if the key is already in the map
        const storedFactory = this.map.get(fullPath)

        // check
        if ( storedFactory ) return 

        // just add the key/value pair to the map
        this.map.set(fullPath, factory)
        
        // return the factoryMap
        return this
    },

    all(f) {
        const val = Array.from(this.map.values())
        if (!val?.length) return []
        return val.map( e => f(e))
    },

    // serialize the top-level factory file index (not node factory bindings)
    makeRaw(refArl) {
        return this.all(factory => factory.getPath(refArl))
    },

}
